/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  fill?: string;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24, fill = "none" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill={fill}>
    <path d="M19.3937 15.1111C20.9664 13.57 22.5603 11.7228 22.5603 9.30556C22.5603 7.76583 21.9487 6.28916 20.8599 5.20041C19.7712 4.11166 18.2945 3.5 16.7548 3.5C14.897 3.5 13.5881 4.02778 12.0048 5.61111C10.4214 4.02778 9.11255 3.5 7.25477 3.5C5.71505 3.5 4.23838 4.11166 3.14963 5.20041C2.06087 6.28916 1.44922 7.76583 1.44922 9.30556C1.44922 11.7333 3.03255 13.5806 4.61589 15.1111L12.0048 22.5L19.3937 15.1111Z" stroke="#262626" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.0063 5.61133L8.88188 8.73577C8.66741 8.94868 8.49719 9.20193 8.38104 9.48092C8.26488 9.75991 8.20508 10.0591 8.20508 10.3613C8.20508 10.6635 8.26488 10.9627 8.38104 11.2417C8.49719 11.5207 8.66741 11.774 8.88188 11.9869C9.74743 12.8524 11.1302 12.8841 12.0485 12.0608L14.2335 10.0552C14.7812 9.55826 15.4943 9.28296 16.2338 9.28296C16.9734 9.28296 17.6864 9.55826 18.2341 10.0552L21.3585 12.863" stroke="#262626" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18.3396 16.1668L16.2285 14.0557" stroke="#262626" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15.1717 19.3338L13.0605 17.2227" stroke="#262626" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
